import { AxiosRequestConfig } from 'axios';
import { HttpResponse, ajax } from '../../../../common/ajax';
import { config } from '../../config';
import {
  FinalReportItemModel,
  PartialReportData,
} from '../../models/FinalReportItem';

interface IFinalReportsService {
  getFinalReports: (
    queryString?: string,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<FinalReportItemModel[]>>;
  downloadFinalReportFile: (
    fileCode: string,
    fileName: string,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<null>>;
  loadAdvanceInvoiceFile: (
    fileCode: string,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<File>>;
  downloadInvoicesZipFile: (
    fileCode: string,
    fileName: string,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<null>>;
  createPartialReport: (
    data: PartialReportData,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<boolean>>;
  getReportStatusForRefresh: (
    processingReportIds: number[],
    axiosConfig?: AxiosRequestConfig<any> | undefined,
  ) => Promise<HttpResponse<boolean>>;
  deleteReport: (
    reportId: number,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<boolean>>;
}

export const finalReportsService: IFinalReportsService = {
  getFinalReports(
    queryString,
    axiosConfig,
  ): Promise<HttpResponse<FinalReportItemModel[]>> {
    return ajax.get<FinalReportItemModel[]>(
      `${config.benefitApiUrl}/odata/final-reports?${queryString}`,
      axiosConfig,
    );
  },
  downloadFinalReportFile(
    fileCode: string,
    fileName: string,
    axiosConfig?: AxiosRequestConfig<any> | undefined,
  ): Promise<HttpResponse<null>> {
    return ajax.downloadFile(
      `${config.benefitApiUrl}/report-file/${fileCode}`,
      fileName,
      'xlsx',
      axiosConfig,
    );
  },
  loadAdvanceInvoiceFile(
    fileCode: string,
    axiosConfig?: AxiosRequestConfig<any> | undefined,
  ): Promise<HttpResponse<File>> {
    return ajax.get<File>(
      `${config.benefitApiUrl}/advance-invoice-file/${fileCode}`,
      {
        ...axiosConfig,
        responseType: 'blob',
      },
    );
  },
  downloadInvoicesZipFile(
    fileCode: string,
    fileName: string,
    axiosConfig?: AxiosRequestConfig<any> | undefined,
  ): Promise<HttpResponse<null>> {
    return ajax.downloadFile(
      `${config.benefitApiUrl}/invoices-file/${fileCode}`,
      fileName,
      'zip',
      axiosConfig,
    );
  },
  createPartialReport(
    data: PartialReportData,
    axiosConfig?: AxiosRequestConfig<any> | undefined,
  ): Promise<HttpResponse<boolean>> {
    return ajax.put(
      `${config.benefitApiUrl}/create-partial-report`,
      data,
      axiosConfig,
    );
  },
  getReportStatusForRefresh(
    processingReportIds: number[],
    axiosConfig?: AxiosRequestConfig<any> | undefined,
  ): Promise<HttpResponse<boolean>> {
    const params = new URLSearchParams();

    for (const id of processingReportIds) {
      params.append('ids', id.toString());
    }

    return ajax.get(
      `${config.benefitApiUrl}/reports-status?${params.toString()}`,
      axiosConfig,
    );
  },
  deleteReport(
    reportId: number,
    axiosConfig?: AxiosRequestConfig<any> | undefined,
  ): Promise<HttpResponse<boolean>> {
    return ajax.delete(
      `${config.benefitApiUrl}/delete-report/${reportId}`,
      axiosConfig,
    );
  },
};
